/**
 * Karşılama turu iki tarafa ayrılır (katalog s. 6).
 *
 * Müşteri: "ilk faturanı çek", AI'a sor, muhasebecini bağla.
 * Ofis: "ekibini davet et, ilk müşterini ekle", eksik belgeler.
 * Personel (davetle gelen): kendi müşterileri ve gelen kutusu; ekip/üyelik yok.
 *
 * Tur penceresi index.html'de (#onb-s1 kartları, #onb-s2 düğmeleri); bu modül
 * yalnızca içeriği tarafa göre yazar. Başlık ve rol rozeti push.js'te.
 */

import { defineFeature } from '../../shell/feature.ts';

const g = globalThis as any;

type Card = [string, string, string];
type Step = [string, string, string, string];

const CARD_CSS = 'background:var(--c2);border-radius:14px;padding:14px;border:1px solid var(--div)';
const BTN_CSS = 'display:flex;align-items:center;gap:14px;padding:16px;border-radius:14px;cursor:pointer;text-align:left;width:100%;';

const CUSTOMER: { sub: string; cards: Card[]; steps: Step[] } = {
  sub: 'Snap your invoices, and your ledger and your accountant stay up to date.',
  cards: [
    ['📷', 'Snap an invoice', 'Photograph a receipt or invoice; it is read into your ledger'],
    ['✦', 'Ask the AI', 'Talk or type: “how is this month going?”'],
    ['⇄', 'Your accountant', 'Connect once; they see and fix your records'],
    ['📊', 'Financial Results', 'Filter any period and download Excel or PDF'],
  ],
  steps: [
    ['📷', 'Photograph your first invoice', 'The AI page reads it into your ledger', "closeOnboarding();go('v6','ni6');setTimeout(function(){if(typeof cuaiCamera==='function')cuaiCamera();},400)"],
    ['✦', 'Ask the AI', 'Ask how your month is going', "closeOnboarding();go('v6','ni6')"],
    ['⇄', 'Connect your accountant', 'Enter the code your accountant gave you', "closeOnboarding();go('v10','ni10')"],
  ],
};

const FIRM: { sub: string; cards: Card[]; steps: Step[] } = {
  sub: 'Your clients, their documents and your team in one place.',
  cards: [
    ['👥', 'Clients', 'Who owes which document, and what can be closed today'],
    ['📥', 'Document requests', 'Ask once; reminders go out on day 3 and 7'],
    ['🧑‍💼', 'Your team', 'Everyone signs in with their own email'],
    ['✓', 'Month close', 'Checklist, lock the month, export'],
  ],
  steps: [
    ['🧑‍💼', 'Invite your team', 'Staff see only the clients you assign', "closeOnboarding();go('v11','ni11')"],
    ['➕', 'Add your first client', 'Generate a one-time code for them', "closeOnboarding();if(typeof fwNav==='function'){fwNav('clients');setTimeout(function(){if(typeof fwToggleLink==='function')fwToggleLink();},400);}"],
    ['✦', 'Ask the AI', '“Which clients are missing documents?”', "closeOnboarding();go('v6','ni6')"],
  ],
};

const STAFF: { sub: string; cards: Card[]; steps: Step[] } = {
  sub: 'Your manager assigns clients to you. Their documents and requests are waiting here.',
  cards: [
    ['👥', 'My clients', 'Only the clients assigned to you'],
    ['📥', 'Inbox', 'Documents your clients uploaded'],
    ['⚠', 'Missing documents', 'What is still missing this month'],
    ['✦', 'AI assistant', '“Open Ahmed and show me the February statement”'],
  ],
  steps: [
    ['👥', 'Open my clients', 'See what needs your attention today', "closeOnboarding();if(typeof fwNav==='function')fwNav('clients')"],
    ['📥', 'Go to the inbox', 'Read new documents into the ledger', "closeOnboarding();if(typeof fwNav==='function')fwNav('inbox')"],
    ['✦', 'Ask the AI', '“What were we doing?”', "closeOnboarding();go('v6','ni6')"],
  ],
};

function apply(): void {
  const s1 = document.getElementById('onb-s1');
  const s2 = document.getElementById('onb-s2');
  if (!s1 || !s2) return;
  const side = g.navSide?.();
  const content = side === 'customer' ? CUSTOMER : side === 'staff' ? STAFF : side ? FIRM : null;
  if (!content) return;

  const sub = document.getElementById('onb-sub');
  if (sub) sub.textContent = content.sub;
  /* Eski "General Manager / Assistant" rozeti tek hesaplı çok kullanıcı döneminden; tarafı söyler. */
  const badge = document.getElementById('onb-role-badge');
  if (badge) {
    const label = side === 'customer' ? '' : side === 'staff' ? 'Staff' : side === 'manager' ? 'Manager' : 'Firm owner';
    badge.textContent = label;
    badge.style.display = label ? 'inline-block' : 'none';
  }

  const grid = s1.querySelector('div[style*="grid-template-columns"]') as HTMLElement | null;
  if (grid) {
    grid.innerHTML = content.cards.map(([icon, title, text]) =>
      `<div style="${CARD_CSS}"><div style="font-size:22px;margin-bottom:6px">${icon}</div>`
      + `<div style="font-size:12px;font-weight:700;color:#fff;margin-bottom:3px">${title}</div>`
      + `<div style="font-size:11px;color:var(--t2);line-height:1.5">${text}</div></div>`).join('');
  }

  const list = s2.querySelector('div[style*="flex-direction:column"]') as HTMLElement | null;
  if (list) {
    list.innerHTML = content.steps.map(([icon, title, text, action], i) =>
      `<button onclick="${action}" style="${BTN_CSS}${i === 0 ? 'background:var(--rA);border:1px solid var(--rB)' : 'background:var(--c2);border:1px solid var(--div)'}">`
      + `<div style="font-size:26px;flex-shrink:0;color:#c4b5fd">${icon}</div>`
      + `<div><div style="font-size:13px;font-weight:700;color:#fff">${title}</div>`
      + `<div style="font-size:11px;color:var(--t2);margin-top:2px">${text}</div></div></button>`).join('');
  }
}

export default defineFeature({
  id: 'onboarding-sides',
  label: 'Karşılama turu (taraf)',
  view: null,
  legacyGlobals: {
    onbApplySide: () => apply(),
  },
});
